module.exports = __webpack_public_path__ + "img/first-layer-2.c40463a4.png";